import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import {
  IconFullWidthToolbar as IconFullWidth,
  IconHalfWidthToolbar as IconHalfWidth,
  IconThreeColumnsToolbar as IconThreeColumns,
  IconFourColumnsToolbar as IconFourColumns,
  IconOneTwoThirdToolbar as IconOneTwoThird,
  IconTwoOneThirdToolbar as IconTwoOneThird,
} from '@hivebrite/design-system/Icon';
import type { Theme } from '@hivebrite/design-system/Theme';

import type {
  Proportions,
  Layout,
} from 'hb-builder/components/common/Wrapper/components/DynamicLayoutToolbar';
import { getIsLayoutSelected } from 'hb-builder/components/common/Wrapper/components/DynamicLayoutToolbar/utils';
import ToolbarButton from 'hb-builder/components/common/Wrapper/components/ToolbarButton';
import { useComponentContext } from 'hb-builder/hooks';

interface DynamicLayoutProps {
  layout: Layout;
  proportions?: Proportions;
  onClick: (e: any) => void;
}

const icons = {
  1: <IconFullWidth size={24} />,
  '2-0.5,0.5': <IconHalfWidth size={24} />,
  '2-0.3,0.7': <IconOneTwoThird size={24} />,
  '2-0.7,0.3': <IconTwoOneThird size={24} />,
  3: <IconThreeColumns size={24} />,
  4: <IconFourColumns size={24} />,
};

const getLayoutSVGIcons = (layout, proportions) => {
  const key = proportions
    ? `${layout}-${proportions.map((proportion) => proportion.toFixed(1))}`
    : layout;

  return icons[key];
};

const DynamicLayout = ({
  layout,
  proportions,
  ...otherProps
}: DynamicLayoutProps) => {
  const { item } = useComponentContext();
  const isSelected = getIsLayoutSelected({
    item,
    layout,
    proportions,
  });

  return (
    <ContainerLayout>
      <StyledToolbarButton
        isSelected={isSelected}
        ariaLabel={s__('Builder|Use %{columnsCount} columns layout').i__({
          columnsCount: layout.toString(),
        })}
        {...otherProps}
      >
        {layout > 0 && getLayoutSVGIcons(layout, proportions)}
      </StyledToolbarButton>
    </ContainerLayout>
  );
};

export default DynamicLayout;

interface DynamicLayoutStylesProps {
  $isSelected?: boolean;
  $layout?: Layout;
  theme: Theme;
}

const ContainerLayout = styled(Box)<DynamicLayoutStylesProps>`
  cursor: pointer;
  margin: 0 2px;
`;

// Needed to be able to target the element from a child's styles block (ie. WrapperLayout)
const StyledToolbarButton = styled(ToolbarButton)``;
